import { makeStyles } from '@material-ui/core/styles'
import { createStyles, Theme } from '@material-ui/core'
import { colorWhite } from '../../shared/style-settings'

export const useAppProgressIndicatorStyles = makeStyles((theme: Theme) =>
  createStyles({
    progressIndicator: {
      zIndex: theme.zIndex.drawer + 1,
      color: colorWhite,
      backdropFilter: 'blur(7px)',
    },
    loaderWrapper: {
      background: colorWhite,
      padding: '3em 6em',
      borderRadius: '0.5em',
    },
  })
)
